"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChallenge = void 0;
const initializer_1 = require("../../../initializer");
const useChallengeBase_hook_1 = require("./useChallengeBase.hook");
const useChallenge = (props) => {
    return (0, useChallengeBase_hook_1.useChallengeBase)({ authoriser: initializer_1.Authoriser, ...props });
};
exports.useChallenge = useChallenge;
//# sourceMappingURL=useChallenge.hook.js.map